import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

const urlPrefix = '/master';

@Injectable({
  providedIn: 'root'
})
export class MasterBackendServer extends BaseBackend {

  getConstant(code: any): Observable<any> {
    return this.get(`${ urlPrefix }/constant?code=${ code }`);
  }

  getCommonConstantList(codes: any): Observable<any> {
    return this.get(`${ urlPrefix }/constants?codes=${ codes }`);
  }

  getStatus(detailType): Observable<any> {
    return this.get(`${ urlPrefix }/${ detailType }/status`);
  }

  getStatusForFilter(detailType): Observable<any> {
    return this.get(`${ urlPrefix }/${ detailType }/status/filter`);
  }

  getProductCategories(): Observable<any> {
    return this.get(`${ urlPrefix }/product/categories`);
  }

  serverFileUpload(formData): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    // change post for progress bar
    const uploadReq = new HttpRequest('POST', `${ this.backend }/upload/file/temp-file`, formData, options);

    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  serverFileDelete(params): Observable<any> {
    const { key } = params;
    return this.delete(`/upload/file?key=${ key }`,);
  }

  imageUrl(key, secretKey) {
    return `${ this.backend }/image/server-file/${ key }?secret=${ secretKey }`;
  }

  tsvCellsUpload(data: any, code, queryString?: any, isSync?): Observable<any> {
    let url = `${ this.backend }/upload/tsv/${ code }`;
    if (queryString) {
      url += `?${ queryString }`;
    }
    return this.http.post(url, { ...data, isSync: isSync });
  }

  getTemplate(templateId): Observable<any> {
    const url = `${ this.backend }/master/download/${ templateId }`
    return this.http.get(url, { responseType: 'arraybuffer' });
  }
}
